module.exports = __webpack_public_path__ + "static/media/ARM.e8c89205.svg";